import { Field, Float, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { Product } from '../../product/Product'

@InputType()
export class GetOrderItemWeightArgs extends ActionArgs {
  @Field(() => Float)
  quantity: number

  @Field(() => Product)
  product?: Product

  @Field(() => String)
  productId?: string
}

export interface IGetOrderItemWeight extends IAction<number, GetOrderItemWeightArgs> {}
